import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { withTheme, taggedStylesToString } from 'common/styling/theme';
import { staticStyles, getDynamicStyles } from './style';

import LoadingIcon from './icons/LoadingIcon';

const DefaultButton = ({
  textId,
  plus,
  next,
  previous,
  filled,
  butColor,
  loading,
  type,
  noBorder,
  theme,
  className,
  isUpperCase,
  ghost,
  wide,
  ...props
}) => {
  const dynamicStyles = Object.keys(theme).length ? taggedStylesToString(getDynamicStyles(theme)) : ` `;

  return (
    <button // eslint-disable-line
      type={type}
      className={classNames(
        'DefaultButton',
        { ghost, plus, next, filled, previous, noBorder, wide, DefaultButton_preload: loading },
        butColor && `DefaultButton__${butColor}`,
        `${className}`
      )}
      {...props}>
      <FormattedMessage id={textId}>
        {txt => <span className="DefaultButton__text">{isUpperCase ? txt.toUpperCase() : txt}</span>}
      </FormattedMessage>
      <span className="DefaultButton__preloader">
        <LoadingIcon />
      </span>
      <style jsx>{staticStyles}</style>
      <style>{dynamicStyles}</style>
    </button>
  );
};

const basePropTypes = {
  textId: PropTypes.string.isRequired,
  plus: PropTypes.bool,
  previous: PropTypes.bool,
  next: PropTypes.bool,
  filled: PropTypes.bool,
  noBorder: PropTypes.bool,
  butColor: PropTypes.string,
  loading: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string,
  isUpperCase: PropTypes.bool,
  ghost: PropTypes.bool,
  wide: PropTypes.bool,
  theme: PropTypes.object,
};

DefaultButton.propTypes = basePropTypes;
DefaultButton.defaultProps = {
  plus: false,
  previous: false,
  next: false,
  filled: false,
  noBorder: false,
  butColor: '',
  loading: false,
  type: 'button',
  className: '',
  isUpperCase: false,
  ghost: false,
  wide: false,
  theme: {},
};

const ThemedButton = withTheme()(DefaultButton);

ThemedButton.propTypes = basePropTypes;

export default ThemedButton;
export { DefaultButton };
